export default {
    message: 'The {_field_} value must only contain alpha numeric characters, numbers or _.',
    validate: (value) => {
        let regex = new RegExp('^[A-Za-z0-9_]+$');
        return regex.test(value);
    }
}
